import './styles/main.css';
import { Engine } from './core/Engine';

window.addEventListener('DOMContentLoaded', () => {
  const canvas = document.getElementById('game-canvas');
  const uiContainer = document.getElementById('ui-container');

  if (!canvas || !uiContainer) {
    console.error('Fatal: Missing game canvas or UI container element.');
    return;
  }

  try {
    const engine = new Engine(canvas, uiContainer);
    engine.start();

    console.log(
      '%c Commodore 64 Arkanoid - 100% Fragment Shader Edition %c Loaded Successfully! ',
      'background: #0000aa; color: #aaffee; font-weight: bold; padding: 4px;',
      'background: #222; color: #eee; padding: 4px;'
    );
  } catch (error) {
    console.error('Failed to initialize game engine:', error);
    uiContainer.innerHTML = `
      <div class="screen-panel" style="border-color: #ff7777;">
        <h2 class="c64-heading red">BOOT ERROR</h2>
        <p class="c64-subtext">${error.message}</p>
        <p class="c64-info">Ensure WebGL hardware acceleration is enabled in browser.</p>
      </div>
    `;
  }
});
